import React from "react";

export const LoadingCard: React.FC = () => {
  return (
    <div className="h-[14.688rem] min-w-[10.938rem] rounded-2xl bg-gray-200 animate-pulse">
      {/* Loading skeleton */}
    </div>
  );
};